import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { getAppProps } from '@pages/_app';
import { buildUniversalDataUrl, buildDataUrl } from '@helper/api';
import { removeTrailingSlash } from '@helper';

const Entry = dynamic(() => import('@components/pages/entry/entry'), { loading: () => null });
const Overview = dynamic(() => import('@components/pages/overview/overview'), {
  loading: () => null
});
const Newsroom = dynamic(() => import('@components/pages/newsroom/newsroom'), {
  loading: () => null
});
const ThinkingSpace = dynamic(() => import('@components/pages/thinking-space/thinkingSpace'), {
  loading: () => null
});
const CuratedExhibition = dynamic(
  () => import('@components/pages/curated-exhibition/curated-exhibition'),
  { loading: () => null }
);
const GuidedTours = dynamic(() => import('@components/pages/guided-tours/guidedTours'), {
  loading: () => null
});

const TourDetails = dynamic(() => import('@components/pages/tour-details/tourDetails'), {
  loading: () => null
});

// Render current page based on type
const CurrentPage = ({ data }) => {
  switch (data.type) {
    case 'listPage':
      return <Overview overviewData={data} />;
    case 'newsroom':
      return <Newsroom data={data} />;
    case 'thinkingSpace':
      return <ThinkingSpace data={data} />;
    case 'curatedExhibition':
      return <CuratedExhibition data={data} />;
    case 'guidedTours':
      return <GuidedTours data={data} />;
    // case 'gomusDate':
    case 'tour':
    case 'gomusTour':
      return <TourDetails data={data} />;
    default:
      return <Entry data={data} />;
  }
};

const getCurrentPageProps = async ({ locale, resolvedUrl }) => {
  console.log('get page:', buildUniversalDataUrl(removeTrailingSlash(`/${locale}${resolvedUrl}`)));

  const getPageProps = fetch(buildUniversalDataUrl(removeTrailingSlash(`/${locale}${resolvedUrl}`)))
    .then(res => res.json())
    .then(async data => {
      const returnData = data;
      // console.log(returnData);
      if (returnData.type === 'listPage' && returnData.listUrl) {
        const rootUrl =
          typeof window === 'undefined' ? process.env.INTERNAL_JSON_API_HOST : process.env.ROOT_URL;
        const listData = await fetch(`${rootUrl}${returnData.listUrl}`);

        const eventFilter = await fetch(
          buildDataUrl(
            `${returnData.lang}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/eventFilterList`
          )
        );

        const list = await listData.json();
        const filter = await eventFilter.json();

        returnData.listData = list;
        returnData.filterCategories = filter;
      }

      if (returnData.type === 'thinkingSpace' || returnData.type === 'curatedExhibition') {
        returnData.floorPlanDataUrl = `${returnData.lang}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/floorplans`;
      }

      return returnData;
    })
    .catch(err => console.error('[uri]/[uri2]/index.jsx ', err));

  const [appProps, pageData] = await Promise.allSettled([
    getAppProps({ locale }),
    getPageProps
  ]).then(results => results.map(result => result.value));

  return {
    PAGE_TYPE: 'UNIVERSAL',
    ...appProps,
    ...pageData
  };
};

CurrentPage.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string.isRequired
  }).isRequired
};

export default CurrentPage;
export { getCurrentPageProps };
